import React from 'react'
import { DetectionsEmptyState } from '../EmptyState'
import { GalleryCard, GalleryItem } from './GalleryCard'
import styles from './Gallery.module.css'

export type GalleryUIProps = {
    items: GalleryItem[]
    selectedIds: string[]
    onToggleSelect: (id: string) => void
    onOpenDetail: (id: string) => void
}

export const GalleryUI: React.FC<GalleryUIProps> = ({ items, selectedIds, onToggleSelect, onOpenDetail }) => (
    <div className={styles.gallery}>
        {items.length === 0 ? (
            <DetectionsEmptyState className={styles.emptyState} />
        ) : (
            items.map((item) => (
                <GalleryCard
                    key={item.id}
                    item={item}
                    isSelected={selectedIds.includes(item.id)}
                    onToggleSelect={onToggleSelect}
                    onOpenDetail={onOpenDetail}
                />
            ))
        )}
    </div>
)
